import { ServiceCodeEnum } from '../enums/service.enum';
import { Option } from '../../shared/components/formbuilder/field-config';

export interface LicenseCategory {
  label: string;
  options: Option[];
}

export const LICENSE_CATEGORIES: LicenseCategory[] = [
  {
    label: 'Banking Licences',
    options: [
      { label: 'Investment Bank Licence', value: ServiceCodeEnum.INVESTMENT_BANK_LICENSE },
      { label: 'Merchant Bank Licence', value: ServiceCodeEnum.MERCHANT_BANK_LICENSE },
      { label: 'Commercial Bank Licence', value: ServiceCodeEnum.COMMERCIAL_BANK_LICENSE },
      { label: 'Full Bank Licence', value: ServiceCodeEnum.FULL_BANK_LICENSE },
      { label: 'Mortgage Bank Licence', value: ServiceCodeEnum.MORTGAGE_BANK_LICENSE },
      { label: 'Digital Bank Licence', value: ServiceCodeEnum.DIGITAL_BANK_LICENSE },
      {
        label: 'Representative Office Licence',
        value: ServiceCodeEnum.REPRESENTATIVE_OFFICE_LICENSE,
      },
    ],
  },
  {
    label: 'Insurance Licences',
    options: [
      { label: 'General Insurance', value: ServiceCodeEnum.GENERAL_INSURANCE },
      { label: 'Long Term Insurance', value: ServiceCodeEnum.LONG_TERM_INSURANCE },
      { label: 'Reinsurance', value: ServiceCodeEnum.REINSURANCE },
      { label: 'Insurance Broker', value: ServiceCodeEnum.INSURANCE_BROKER },
      { label: 'Insurance Agency', value: ServiceCodeEnum.INSURANCE_AGENCY },
    ],
  },
  {
    label: 'Capital Markets Licences',
    options: [
      { label: 'Dealer Broker', value: ServiceCodeEnum.DEALER_BROKER },
      { label: 'Investment Advisor', value: ServiceCodeEnum.INVESTMENT_ADVISOR },
      {
        label: 'Stock Exchange',
        value: ServiceCodeEnum.STOCK_EXCHANGE,
      },
      {
        label: 'Crypto Exchange',
        value: ServiceCodeEnum.CRYPTO_EXCHANGE,
      },
      {
        label: 'Central Securities Depository',
        value: ServiceCodeEnum.CENTRAL_SECURITIES_DEPOSITORY,
      },
      {
        label: ' Clearing House',
        value: ServiceCodeEnum.CLEARING_HOUSE,
      },
      
      { label: 'CIS', value: ServiceCodeEnum.CIS },
      { label: 'CIS Fund Manager ', value: ServiceCodeEnum.CIS_FUND_MANAGER },
      { label: 'CISTrustee', value: ServiceCodeEnum.CIS_TRUSTEE },
      { label: 'Credit Rating Agency', value: ServiceCodeEnum.CREDIT_RATING_AGENCY },
      { label: 'Custody / Wallet Services', value: ServiceCodeEnum.CUSTODY_WALLET_SERVICES },
      { label: 'Crowdfunding Platform', value: ServiceCodeEnum.CROWDFUNDING_PLATFORM },
    ],
  },
  {
    label: 'Ancillary Licences',
    options: [
      { label: 'Legal Services Firm', value: ServiceCodeEnum.LEGAL_SERVICES_FIRM },
      { label: 'Accounting Firm', value: ServiceCodeEnum.ACCOUNTING_FIRM },
      { label: 'Auditing Firm', value: ServiceCodeEnum.AUDITING_FIRM },
      { label: 'Business Consulting Firm', value: ServiceCodeEnum.BUSINESS_CONSULTING_FIRM },
    ],
  },
  {
    label: 'FinTech Licences',
    options: [
      { label: 'Sandbox Licence', value: ServiceCodeEnum.SANDBOX },
      { label: 'Full Custodial Licence', value: ServiceCodeEnum.FULL_CUSTODIAL },
      { label: 'Full Non-Custodial Licence', value: ServiceCodeEnum.FULL_NON_CUSTODIAL },
      { label: 'Token Issuance Licence', value: ServiceCodeEnum.TOKEN_ISSUANCE },
      { label: 'Payment Services Provider', value: ServiceCodeEnum.PAYMENT_SERVICES_PROVIDER },
      {
        label: 'Digital Asset Service Provider',
        value: ServiceCodeEnum.DIGITAL_ASSET_SERVICE_PROVIDER,
      },
    ],
  },
  {
    label: 'Gaming Licences',
    options: [
      { label: 'Lotto Licence', value: ServiceCodeEnum.LOTTO },
      { label: 'E-Casino Licence', value: ServiceCodeEnum.ECASINO },
      { label: 'Sports Betting Licence', value: ServiceCodeEnum.SPORTS_BETTING },
    ],
  },
];

/**
 * Get all license options as a flat array
 */
export const getAllLicenseOptions = (): Option[] => {
  return LICENSE_CATEGORIES.flatMap((category) => category.options);
};

/**
 * Get license label by value
 */
export const getLicenseLabel = (value: string): string => {
  const option = getAllLicenseOptions().find((opt) => opt.value === value);
  return option?.label || value;
};
